import SideBarImage from "./SideBarImage";
import NavigationBarList from "./NavigationBarList";
import { BiSolidLeftArrow } from "react-icons/bi";
import { useSelector, useDispatch } from "react-redux";
import { updateMenuDrawer } from "../../reducer/appReducer";
import { updateDisplayOverLayingHamburgerMenu } from "../../reducer/appHeaderReducer";
import useSidebarCollapsed from "../../hooks/useSidebarCollapsed";
import menu from "../../assetsV2/SideBarImage/menu.svg";

const SidebarGeneric = ({ dashboardSelectHandler }) => {
  const categories = useSelector((state) => state.categories.data);
  const { menuDrawer } = useSelector((store) => store.app);
  const {
    isMobileAndTabletScreen,
    isMobileScreen,
    displayOverlayingHamburgerMenu,
  } = useSelector((store) => store.appHeader);
  const collapsed = useSidebarCollapsed();

  const dispatch = useDispatch();

  const isTablet = Boolean(isMobileAndTabletScreen && !isMobileScreen);
  const isOpen = !isTablet || displayOverlayingHamburgerMenu;

  let Categories = categories?.length > 0 ? ["All Menu", ...categories] : [];

  const cats = Categories.map((category, index) => ({
    id: index,
    title: category,
    image: category,
    type: "category",
  }));

  const closeTabletDrawer = () =>
    dispatch(updateDisplayOverLayingHamburgerMenu(false));

  const handleToggle = () => {
    if (isTablet) closeTabletDrawer();
    else dispatch(updateMenuDrawer(!menuDrawer));
  };

  const handleSelect = (item) => {
    dashboardSelectHandler(item);
    if (isTablet) closeTabletDrawer();
  };

  const placementClass = isTablet
    ? `w-[13rem] z-[1002] shadow-xl ${
        isOpen ? "translate-x-0 visible" : "-translate-x-full invisible"
      }`
    : `${collapsed ? "w-[5rem]" : "w-[13rem]"} translate-x-0 z-[300]`;

  return (
    <>
      {isTablet && isOpen && (
        <div
          data-testid="sidebar-backdrop"
          className="fixed inset-0 z-[1001]"
          onClick={closeTabletDrawer}
        />
      )}

      <aside
        data-testid="sidebar"
        aria-hidden={isTablet ? !isOpen : undefined}
        className={`onboarding-sidebar-dashboard ${placementClass} fixed top-0 bottom-0 left-0 overflow-hidden hover:overflow-y-auto transition-[width,transform,visibility] duration-300 ease-in-out motion-reduce:transition-none`}
      >
        {/* Fixed-width inner so labels never reflow while the width animates */}
        <div className={collapsed ? "w-[5rem]" : "w-[13rem]"}>
          <div className="flex">
            {!collapsed && <SideBarImage />}

            {collapsed ? (
              <img
                src={menu}
                alt=""
                role="button"
                aria-label="Expand sidebar"
                onClick={handleToggle}
                className="text-fg-inverse mt-[4.6rem] ml-[30px]  cursor-pointer text-1xl"
              />
            ) : (
              <BiSolidLeftArrow
                role="button"
                aria-label={isTablet ? "Close sidebar" : "Collapse sidebar"}
                onClick={handleToggle}
                className="text-fg-inverse mt-[3.8rem] md:mt-[4.3rem] lg:mt-[4.6rem] absolute right-[10px] top-[1px] cursor-pointer text-xs"
              />
            )}
          </div>
          <NavigationBarList
            categories={cats}
            dashboardSelectHandler={handleSelect}
          />
        </div>
      </aside>
    </>
  );
};

export default SidebarGeneric;
